import { PreferenceCategory } from './preference-category.model';

export class AccountStayPreferences {
  categories: Array<object>;

  constructor(data, differences) {
    let stayPreferences = (data || {});
    let updates = (differences || {});
    this.categories = [];
    this._mapData(stayPreferences, updates);
  }

  _mapData(stayPreferences, updates) {
    if(!!stayPreferences.categories){
      stayPreferences.categories.forEach((category) => {
        if (category.preferences[0]) {
          this.categories.push(new PreferenceCategory(category, updates));
        }
      });
    }
  }
}





// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/stay-preferences/stay-preference.model.ts